import { type DocumentType, Gender, FareType } from '../types';

export const documentTypes = {
  ID: 'УЛ',
  BIRTH_CERT: 'СР',
  PASSPORT_KZ: 'ПК',
  RESIDENT_CARD: 'ВЖ',
  PASSPORT_RU: 'ПН',
  ID_WITHOUT_CITIZENSHIP: 'БГ',
  OTHER_INT_DOCUMENTS: 'ЗЗ',
  INT_PASSPORT_RU: 'ЗП',
  MILITARY_ID: 'ВБ',
  ID_LOSS_CERT: 'СУ',
  RELEASE_CERT: 'СО',
  PASSPORT_UZ: 'ПУ',
} as const;

export const defaultPassengerData = {
  id: '',
  firstName: '',
  lastName: '',
  fareType: FareType.ADULT,
  documentType: documentTypes.ID as DocumentType, // Type casting for TS to understand that documentType is of type DocumentType, not passengersConfig.documentTypes.ID
  documentNumber: '',
  iin: {
    value: '',
    hasIin: true, // Iin is required only for ID and Passport of Kazakhstan. In other cases it can be omitted
  },
  patronymic: {
    value: '',
    hasPatronymic: true, // Patronymic is required for transit routes. Some passengers do not have patronymic, so it can be omitted
  },
  citizenship: 'KZ',
  gender: '' as Gender,
  dateOfBirth: '',
};
